<template>
  <div :class="getNavBackground()">
    <div class="nav-top">
      <nav-top></nav-top>
    </div>
    <!--养老院账号页面 v-if="moduletag === 2"-->
    <div v-if="moduletag === 2">
      <org-nav-bottom></org-nav-bottom>
    </div>
    <div v-else>
      <jujia-nav></jujia-nav>
    </div>
  </div>
</template>

<script>
import navTop from './childNavBar/navTop'
import orgNavBottom from './childNavBar/orgNavBottom'
import jujiaNav from './childNavBar/jujiaNav.vue'
export default {
  name: 'navBar',
  components: {
    navTop,
    orgNavBottom,
    jujiaNav
  },
  data () {
    return {
      isShangHai: true,
      evenNumber: true,
      role: '',
      scene: '',
      isWeiNing: true,
      moduletag: ''
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
    this.isShangHai = this.$store.state.user.isShangHai
    this.role = this.$store.state.user.role
    this.evenNumber = this.$store.getters.get_evenNumber
    this.scene = this.$store.state.user.scene
  },
  mounted () {
  },
  methods: {
    // 8.13居家新UI
    getNavBackground () {
      if (this.moduletag === 2) {
        return 'sh-nav-bar3'
      } else {
        return 'sh-nav-bar4'
      }
    }
  }
}
</script>

<style scoped>
  .sh-nav-bar3{
    width: 100%;
    height: 60px;
    background: url("../../assets/SHscreen/top_bg.png") no-repeat left;
  }
  .sh-nav-bar4{
    width: 100%;
    height: 60px;
    background: url("../../assets/SHscreen/top_bg1.png") no-repeat left;
  }
  .nav-top{
    width: 100%;
    height: 30px;
    z-index: 99;
  }
</style>



// WEBPACK FOOTER //
// src/components/navbar/index.vue